window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.submission_form = window.locales.am.submission_form || {};window.locales.am.submission_form = {...window.locales.am.submission_form, ...{
    "title": "ፕሮጀክትዎን ያስገቡ",

                          
    "description": "ፕሮጀክትዎን ለማስገባት ይህን ቅጽ ይሙሉ። በኢሜይል አያስገቡ። ማንኛውም ጥያቄ ካለዎት {email} ያግኙን።",
    "description_group_project": "ፕሮጀክትዎን ለማስገባት ይህን ቅጽ ይሙሉ። በኢሜይል አያስገቡ። ማንኛውም ጥያቄ ካለዎት {email} ያግኙን።\n\nለቡድን ማስገባቶች፣ እባክዎ ሁሉም የቡድን አባላት ተመሳሳይ ፕሮጀክት በግል መስቀላቸውን ያረጋግጡ።",
    "individual_submission_banner_message": "<medium>በግል እየላኩ ነው</medium><regular>ለዚህ ፕሮጀክት ምንም ቡድን አልተዘጋጀም። በቡድን እየሰሩ ከሆነ፣ ከመላክዎ በፊት ይፍጠሩት።</regular>",
    "group_project_submission_banner_message": "<medium>በቡድንዎ ስም እየላኩ ነው</medium><regular>ሁሉም የቡድን አባላት ተመሳሳይ ነጥብ እና አስተያየት ያገኛሉ። አንድ አባል ብቻ ለቡድን ማስገባት ይችላል።</regular>",
    "create_group": "ቡድን ፍጠር",
    "view_group": "ቡድን ይመልከቱ",

                            
    "group_project_label": "የትብብር አይነት",
    "group_project_description": "በግል ሰርተዋል ወይስ በቡድን?",
    "collaboration_type_individual_radio_label": "በግል",
    "collaboration_type_group_radio_label": "ቡድን",
    "group_project_agreement_description": "እባክዎ የተፈረመ የቡድን ፕሮጀክት ስምምነት ቅጂ ይስቀሉ",
    "group_project_agreement_file_input_button_text": "የቡድን ፕሮጀክት ስምምነት ስቀል",
    "group_project_agreement_file_input_note": "ከፍተኛ የፋይል መጠን 10MB",

                                                                                
    "file_input_button_text": "ፋይል ስቀል",
    "file_input_note": "ከፍተኛ የፋይል መጠን 40MB",
    "file_type_error_pdf": "እባክዎ PDF ሰነድ ያስገቡ።",
    "file_type_error_xlsx": "እባክዎ Excel spreadsheet (.xlsx) ያስገቡ।",
    "file_type_error_zip": "እባክዎ ZIP ፋይል ያስገቡ።",
    "link_input_label": "ሊንኩን እዚህ ይለጥፉ",
    "spreadsheet_google_sheets_guidance": "Google Sheets እየተጠቀሙ ከሆነ፣ እባክዎ የስፕሬድሺት ፋይልዎን እንደ Excel ፋይል (.xlsx) ያውርዱ፡ ወደ File → Download → Microsoft Excel (.xlsx) በመሄድ።",

                                 
                         
    "format_github_link_label": "የ GitHub ማከማቻ ሊንክ",
    "format_github_link_description": "እባክዎ የ GitHub URL ያቅርቡ።",
    "format_github_link_error": "እባክዎ ትክክለኛ የ GitHub URL ያቅርቡ (ለምሳሌ: https://github.com/username/repository)",

                               
    "format_presentation_link_label": "የአቀራረብ ሊንክ",
    "format_presentation_link_description": "እባክዎ የቪዲዮ አቀራረብ URL ያቅርቡ።",
    "format_presentation_link_error": "እባክዎ ትክክለኛ URL ያቅርቡ",

                 
    "format_pdf_label": "የፕሮጀክት ፋይል",
    "format_pdf_description": "እባክዎ PDF ፋይል ይስቀሉ።",

                         
    "format_spreadsheet_label": "የስፕሬድሺት ፋይል",
    "format_spreadsheet_description": "እባክዎ የስፕሬድሺት ፋይል ይስቀሉ።",

                 
    "format_zip_label": "የፕሮጀክት ፋይል",
    "format_zip_description": "እባክዎ ZIP ፋይል ይስቀሉ።",

                          
    "format_generic_link_label": "የፕሮጀክት ሊንክ",
    "format_generic_link_description": "እባክዎ URL ያቅርቡ።",

                           
    "requirements_label_standard_capstone": "የፕሮጀክት መስፈርቶች",
    "requirements_label_presentation": "የአቀራረብ መስፈርቶች",
    "requirements_confirm_label": "የፕሮጀክት ማስገባቴ ከላይ እና በፕሮጀክቱ መመሪያ ውስጥ የተገለጹትን መስፈርቶች የሚያሟላ መሆኑን አረጋግጣለሁ።",
    "requirements_confirm_group_project_label": "ይህ የመጨረሻ ፕሮጀክታችን መሆኑን አረጋግጣለሁ እና ሁሉም አባላት ተመሳሳይ ነጥብ እና አስተያየት እንደሚያገኙ አምናለሁ።",

                         
    "submit_project": "ፕሮጀክት አስገባ",
    "submitting": "እየተላከ ነው፣ እባክዎ ይጠብቁ...",

                        
    "project_submitted_success": "ተሳክቷል! ፕሮጀክትዎ ገብቷል! የእርስዎ ዳሽቦርድ የማስገባት ሁኔታዎን ለማንጸባረቅ ተዘምኗል።",
    "individual_project_submitted_success": "<semi-strong>ተሳክቷል! ፕሮጀክትዎ ገብቷል!</semi-strong> የእርስዎ ዳሽቦርድ የማስገባት ሁኔታዎን ለማንጸባረቅ ተዘምኗል።",
    "group_project_submitted_success": "<semi-strong>ተሳክቷል! ፕሮጀክትዎ በቡድንዎ ስም ገብቷል።</semi-strong> የሁሉም የቡድን አባላት ዳሽቦርድ የማስገባት ሁኔታን ለማንጸባረቅ ተዘምኗል።",
    "project_already_submitted": "ይህን ፕሮጀክት አስቀድመው አስገብተዋል። እንደገና ለማስገባት ከፈለጉ እባክዎ <email/> ያግኙን።",
    "project_waived": "ፕሮጀክትዎ እንደ ያለፈ ተምረጥቷል። ለዚህ ተግባር ሙሉ ነጥብ አግኝተዋል።",
    "return_to_dashboard": "ወደ ዳሽቦርድ ተመለስ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.submission_form = window.locales.ar.submission_form || {};window.locales.ar.submission_form = {...window.locales.ar.submission_form, ...{
    "title": "قدم مشروعك",

                          
    "description": "لتقديم مشروعك، أكمل هذا النموذج. لا تقدم عبر البريد الإلكتروني. إذا كان لديك أي أسئلة، اتصل بـ {email}.",
    "description_group_project": "لتقديم مشروعك، أكمل هذا النموذج. لا تقدم عبر البريد الإلكتروني. إذا كان لديك أي أسئلة، اتصل بـ {email}.\n\nللمشاريع الجماعية، يرجى التأكد من أن جميع أعضاء المجموعة يرفعون نفس المشروع بشكل فردي.",
    "individual_submission_banner_message": "<medium>أنت تقدم بشكل فردي</medium><regular>لم يتم إنشاء مجموعة لهذا المشروع. إذا كنت تعمل في مجموعة، قم بإنشائها قبل التقديم.</regular>",
    "group_project_submission_banner_message": "<medium>أنت تقدم نيابة عن مجموعتك</medium><regular>سيحصل جميع أعضاء المجموعة على نفس الدرجة والتعليقات. يمكن لعضو واحد فقط التقديم نيابة عن المجموعة.</regular>",
    "create_group": "إنشاء مجموعة",
    "view_group": "عرض المجموعة",

                            
    "group_project_label": "نوع التعاون",
    "group_project_description": "هل عملت بشكل فردي أم في مجموعة؟",
    "collaboration_type_individual_radio_label": "فردي",
    "collaboration_type_group_radio_label": "مجموعة",
    "group_project_agreement_description": "يرجى رفع نسخة من اتفاقية المشروع الجماعي الموقعة",
    "group_project_agreement_file_input_button_text": "رفع اتفاقية المشروع الجماعي",
    "group_project_agreement_file_input_note": "الحد الأقصى لحجم الملف 10 ميجابايت",

                                                                                
    "file_input_button_text": "رفع ملف",
    "file_input_note": "الحد الأقصى لحجم الملف 40 ميجابايت",
    "file_type_error_pdf": "يرجى تقديم مستند PDF.",
    "file_type_error_xlsx": "يرجى تقديم جدول بيانات Excel (.xlsx).",
    "file_type_error_zip": "يرجى تقديم ملف ZIP.",
    "link_input_label": "الصق الرابط هنا",
    "spreadsheet_google_sheets_guidance": "إذا كنت تستخدم Google Sheets، يرجى تنزيل جدول البيانات كملف Excel (.xlsx) بالذهاب إلى File → Download → Microsoft Excel (.xlsx).",

                                 
                         
    "format_github_link_label": "رابط مستودع GitHub",
    "format_github_link_description": "يرجى تقديم عنوان URL لـ GitHub.",
    "format_github_link_error": "يرجى تقديم عنوان URL صالح لـ GitHub (مثال: https://github.com/username/repository)",

                               
    "format_presentation_link_label": "رابط العرض التقديمي",
    "format_presentation_link_description": "يرجى تقديم عنوان URL للعرض التقديمي بالفيديو.",
    "format_presentation_link_error": "يرجى تقديم عنوان URL صالح",

                 
    "format_pdf_label": "ملف المشروع",
    "format_pdf_description": "يرجى رفع ملف PDF.",

                         
    "format_spreadsheet_label": "ملف جدول البيانات",
    "format_spreadsheet_description": "يرجى رفع ملف جدول بيانات.",

                 
    "format_zip_label": "ملف المشروع",
    "format_zip_description": "يرجى رفع ملف ZIP.",

                          
    "format_generic_link_label": "رابط المشروع",
    "format_generic_link_description": "يرجى تقديم عنوان URL.",

                           
    "requirements_label_standard_capstone": "متطلبات المشروع",
    "requirements_label_presentation": "متطلبات العرض التقديمي",
    "requirements_confirm_label": "أؤكد أن تقديم مشروعي يلبي المتطلبات المحددة أعلاه وفي توجيهات المشروع.",
    "requirements_confirm_group_project_label": "أؤكد أن هذا مشروعنا النهائي وأقر بأن جميع الأعضاء سيشاركون نفس الدرجة والتعليقات.",

                         
    "submit_project": "تقديم المشروع",
    "submitting": "جاري التقديم، يرجى الانتظار...",

                        
    "project_submitted_success": "نجح! تم تقديم مشروعك! تم تحديث لوحة التحكم الخاصة بك لتعكس حالة التقديم.",
    "individual_project_submitted_success": "<semi-strong>نجح! تم تقديم مشروعك!</semi-strong> تم تحديث لوحة التحكم الخاصة بك لتعكس حالة التقديم.",
    "group_project_submitted_success": "<semi-strong>نجح! تم تقديم مشروعك نيابة عن مجموعتك.</semi-strong> تم تحديث لوحة التحكم لجميع أعضاء المجموعة لتعكس حالة التقديم.",
    "project_already_submitted": "لقد قمت بالفعل بتقديم هذا المشروع. يرجى الاتصال بـ <email/> إذا كنت بحاجة إلى إعادة التقديم.",
    "project_waived": "تم وضع علامة على مشروعك كمجتاز. لقد حصلت على الدرجة الكاملة لهذا المهمة.",
    "return_to_dashboard": "العودة إلى لوحة التحكم"
}
};window.locales.en = window.locales.en || {};window.locales.en.submission_form = window.locales.en.submission_form || {};window.locales.en.submission_form = {...window.locales.en.submission_form, ...{
    "title": "Submit Your Project",

                          
    "description": "To submit your project, complete this form. Do not submit through email. If you have any questions, contact {email}.",
    "description_group_project": "To submit your project, complete this form. Do not submit through email. If you have any questions, contact {email}.\n\nFor group submissions, please ensure all group members upload the same project individually.",
    "individual_submission_banner_message": "<medium>You are submitting individually</medium><regular>No group is set up for this project. If you're working in a group, create it before submitting.</regular>",
    "group_project_submission_banner_message": "<medium>You are submitting on behalf of your group</medium><regular>All group members will receive the same score and feedback. Only one member may submit for the group.</regular>",
    "create_group": "Create Group",
    "view_group": "View Group",

                            
    "group_project_label": "Collaboration Type",
    "group_project_description": "Did you work individually or in a group?",
    "collaboration_type_individual_radio_label": "Individually",
    "collaboration_type_group_radio_label": "Group",
    "group_project_agreement_description": "Please upload a copy of your signed Group Project Agreement",
    "group_project_agreement_file_input_button_text": "Upload Group Project Agreement",
    "group_project_agreement_file_input_note": "Maximum file size 10MB",

                                        
    "variant_selection_label": "Project Option",

                                                                                
    "file_input_button_text": "Upload File",
    "file_input_note": "Maximum file size 40MB",
    "file_type_error_pdf": "Please submit a PDF document.",
    "file_type_error_xlsx": "Please submit an Excel spreadsheet (.xlsx).",
    "file_type_error_zip": "Please submit a ZIP file.",
    "link_input_label": "Paste link here",
    "spreadsheet_google_sheets_guidance": "If you're using Google Sheets, please download your spreadsheet as an Excel file (.xlsx) by going to File → Download → Microsoft Excel (.xlsx).",

                                 
                         
    "format_github_link_label": "GitHub Repository Link",
    "format_github_link_description": "Please provide a GitHub URL.",
    "format_github_link_error": "Please provide a valid GitHub URL (e.g., https://github.com/username/repository)",

                               
    "format_presentation_link_label": "Presentation Link",
    "format_presentation_link_description": "Please provide a video presentation URL.",
    "format_presentation_link_error": "Please provide a valid URL",

                 
    "format_pdf_label": "Project File",
    "format_pdf_description": "Please upload a PDF file.",

                         
    "format_spreadsheet_label": "Spreadsheet File",
    "format_spreadsheet_description": "Please upload a spreadsheet file.",

                 
    "format_zip_label": "Project File",
    "format_zip_description": "Please upload a ZIP file.",

                          
    "format_generic_link_label": "Project Link",
    "format_generic_link_description": "Please provide a URL.",

                           
    "requirements_label_standard_capstone": "Project Requirements",
    "requirements_label_presentation": "Presentation Requirements",
    "requirements_confirm_label": "I confirm that my project submission meets the requirements specified above and in the project prompt.",
    "requirements_confirm_group_project_label": "I confirm that this is our final project and acknowledge that all members will share the same score and feedback.",

                         
    "submit_project": "Submit project",
    "submitting": "Submitting, please wait...",

                        
    "project_submitted_success": "Success! Your project has been submitted! Your dashboard has been updated to reflect your submission status.",
    "individual_project_submitted_success": "<semi-strong>Success! Your project has been submitted!</semi-strong> Your dashboard has been updated to reflect your submission status.",
    "group_project_submitted_success": "<semi-strong>Success! Your project has been submitted on behalf of your group.</semi-strong> The dashboard for all group members has been updated to reflect the submission status.",
    "project_already_submitted": "You have already submitted this project. Please contact <email/> if you need to resubmit.",
    "project_waived": "Your project has been marked as passed. You have received full credit for this assignment.",
    "return_to_dashboard": "Return to dashboard",

                       
    "submission_error_generic": "An error occurred while submitting. Please try again."
}
};window.locales.es = window.locales.es || {};window.locales.es.submission_form = window.locales.es.submission_form || {};window.locales.es.submission_form = {...window.locales.es.submission_form, ...{
    "title": "Envía tu proyecto",

                          
    "description": "Para enviar tu proyecto, completa este formulario. No envíes por correo electrónico. Si tienes alguna pregunta, contacta a {email}.",
    "description_group_project": "Para enviar tu proyecto, completa este formulario. No envíes por correo electrónico. Si tienes alguna pregunta, contacta a {email}.\n\nPara envíos grupales, asegúrate de que todos los miembros del grupo suban el mismo proyecto individualmente.",
    "individual_submission_banner_message": "<medium>Estás enviando individualmente</medium><regular>No se ha configurado ningún grupo para este proyecto. Si estás trabajando en grupo, créalo antes de enviar.</regular>",
    "group_project_submission_banner_message": "<medium>Estás enviando en nombre de tu grupo</medium><regular>Todos los miembros del grupo recibirán la misma calificación y retroalimentación. Solo un miembro puede enviar por el grupo.</regular>",
    "create_group": "Crear Grupo",
    "view_group": "Ver Grupo",

                            
    "group_project_label": "Tipo de colaboración",
    "group_project_description": "¿Trabajaste individualmente o en grupo?",
    "collaboration_type_individual_radio_label": "Individual",
    "collaboration_type_group_radio_label": "Grupo",
    "group_project_agreement_description": "Por favor, sube una copia de tu Acuerdo de Proyecto Grupal firmado",
    "group_project_agreement_file_input_button_text": "Subir Acuerdo de Proyecto Grupal",
    "group_project_agreement_file_input_note": "Tamaño máximo de archivo 10MB",

                                                                                
    "file_input_button_text": "Subir archivo",
    "file_input_note": "Tamaño máximo de archivo 40MB",
    "file_type_error_pdf": "Por favor, envía un documento PDF.",
    "file_type_error_xlsx": "Por favor, envía una hoja de cálculo Excel (.xlsx).",
    "file_type_error_zip": "Por favor, envía un archivo ZIP.",
    "link_input_label": "Pega el enlace aquí",
    "spreadsheet_google_sheets_guidance": "Si usas Google Sheets, descarga tu hoja de cálculo como archivo Excel (.xlsx) yendo a Archivo → Descargar → Microsoft Excel (.xlsx).",

                                 
                         
    "format_github_link_label": "Enlace del repositorio de GitHub",
    "format_github_link_description": "Por favor, proporciona una URL de GitHub.",
    "format_github_link_error": "Por favor, proporciona una URL válida de GitHub (ej: https://github.com/usuario/repositorio)",

                               
    "format_presentation_link_label": "Enlace de presentación",
    "format_presentation_link_description": "Por favor, proporciona una URL de presentación en video.",
    "format_presentation_link_error": "Por favor, proporciona una URL válida",

                 
    "format_pdf_label": "Archivo del proyecto",
    "format_pdf_description": "Por favor, sube un archivo PDF.",

                         
    "format_spreadsheet_label": "Archivo de hoja de cálculo",
    "format_spreadsheet_description": "Por favor, sube un archivo de hoja de cálculo.",

                 
    "format_zip_label": "Archivo del proyecto",
    "format_zip_description": "Por favor, sube un archivo ZIP.",

                          
    "format_generic_link_label": "Enlace del proyecto",
    "format_generic_link_description": "Por favor, proporciona una URL.",

                           
    "requirements_label_standard_capstone": "Requisitos del Proyecto",
    "requirements_label_presentation": "Requisitos de Presentación",
    "requirements_confirm_label": "Confirmo que mi envío del proyecto cumple con los requisitos especificados anteriormente y en las instrucciones del proyecto.",
    "requirements_confirm_group_project_label": "Confirmo que este es nuestro proyecto final y reconozco que todos los miembros compartirán la misma calificación y retroalimentación.",

                         
    "submit_project": "Enviar proyecto",
    "submitting": "Enviando, por favor espera...",

                        
    "project_submitted_success": "¡Éxito! ¡Tu proyecto ha sido enviado! Tu panel de control ha sido actualizado para reflejar el estado de tu envío.",
    "individual_project_submitted_success": "<semi-strong>¡Éxito! ¡Tu proyecto ha sido enviado!</semi-strong> Tu panel de control ha sido actualizado para reflejar el estado de tu envío.",
    "group_project_submitted_success": "<semi-strong>¡Éxito! Tu proyecto ha sido enviado en nombre de tu grupo.</semi-strong> El panel de control de todos los miembros del grupo ha sido actualizado para reflejar el estado del envío.",
    "project_already_submitted": "Ya has enviado este proyecto. Por favor, contacta a <email/> si necesitas volver a enviarlo.",
    "project_waived": "Tu proyecto ha sido marcado como aprobado. Has recibido crédito completo para esta tarea.",
    "return_to_dashboard": "Volver al panel de control"
}
};window.locales.it = window.locales.it || {};window.locales.it.submission_form = window.locales.it.submission_form || {};window.locales.it.submission_form = {...window.locales.it.submission_form, ...{
    "title": "Invia il tuo progetto",

                          
    "description": "Per inviare il tuo progetto, completa questo modulo. Non inviare tramite email. Se hai domande, contatta {email}.",
    "description_group_project": "Per inviare il tuo progetto, completa questo modulo. Non inviare tramite email. Se hai domande, contatta {email}.\n\nPer gli invii di gruppo, assicurati che tutti i membri del gruppo carichino lo stesso progetto individualmente.",
    "individual_submission_banner_message": "<medium>Stai inviando individualmente</medium><regular>Non è stato creato nessun gruppo per questo progetto. Se stai lavorando in gruppo, crealo prima di inviare.</regular>",
    "group_project_submission_banner_message": "<medium>Stai inviando per conto del tuo gruppo</medium><regular>Tutti i membri del gruppo riceveranno lo stesso punteggio e feedback. Solo un membro può inviare per il gruppo.</regular>",
    "create_group": "Crea Gruppo",
    "view_group": "Visualizza Gruppo",

                            
    "group_project_label": "Tipo di collaborazione",
    "group_project_description": "Hai lavorato individualmente o in gruppo?",
    "collaboration_type_individual_radio_label": "Individuale",
    "collaboration_type_group_radio_label": "Gruppo",
    "group_project_agreement_description": "Si prega di caricare una copia del vostro Accordo di Progetto di Gruppo firmato",
    "group_project_agreement_file_input_button_text": "Carica Accordo di Progetto di Gruppo",
    "group_project_agreement_file_input_note": "Dimensione massima del file 10MB",

                                                                                
    "file_input_button_text": "Carica file",
    "file_input_note": "Dimensione massima del file 40MB",
    "file_type_error_pdf": "Si prega di inviare un documento PDF.",
    "file_type_error_xlsx": "Si prega di inviare un foglio di calcolo Excel (.xlsx).",
    "file_type_error_zip": "Si prega di inviare un file ZIP.",
    "link_input_label": "Incolla il link qui",
    "spreadsheet_google_sheets_guidance": "Se utilizzi Google Sheets, scarica il tuo foglio di calcolo come file Excel (.xlsx) andando su File → Scarica → Microsoft Excel (.xlsx).",

                                 
                         
    "format_github_link_label": "Link del repository GitHub",
    "format_github_link_description": "Si prega di fornire un URL GitHub.",
    "format_github_link_error": "Si prega di fornire un URL GitHub valido (es: https://github.com/utente/repository)",

                               
    "format_presentation_link_label": "Link della presentazione",
    "format_presentation_link_description": "Si prega di fornire un URL della presentazione video.",
    "format_presentation_link_error": "Si prega di fornire un URL valido",

                 
    "format_pdf_label": "File del progetto",
    "format_pdf_description": "Si prega di caricare un file PDF.",

                         
    "format_spreadsheet_label": "File del foglio di calcolo",
    "format_spreadsheet_description": "Si prega di caricare un file del foglio di calcolo.",

                 
    "format_zip_label": "File del progetto",
    "format_zip_description": "Si prega di caricare un file ZIP.",

                          
    "format_generic_link_label": "Link del progetto",
    "format_generic_link_description": "Si prega di fornire un URL.",

                           
    "requirements_label_standard_capstone": "Requisiti del Progetto",
    "requirements_label_presentation": "Requisiti di Presentazione",
    "requirements_confirm_label": "Confermo che l'invio del mio progetto soddisfa i requisiti specificati sopra e nelle istruzioni del progetto.",
    "requirements_confirm_group_project_label": "Confermo che questo è il nostro progetto finale e riconosco che tutti i membri condivideranno lo stesso punteggio e feedback.",

                         
    "submit_project": "Invia progetto",
    "submitting": "Invio in corso, attendere prego...",

                        
    "project_submitted_success": "Successo! Il tuo progetto è stato inviato! La tua dashboard è stata aggiornata per riflettere lo stato di invio.",
    "individual_project_submitted_success": "<semi-strong>Successo! Il tuo progetto è stato inviato!</semi-strong> La tua dashboard è stata aggiornata per riflettere lo stato di invio.",
    "group_project_submitted_success": "<semi-strong>Successo! Il tuo progetto è stato inviato per conto del tuo gruppo.</semi-strong> La dashboard di tutti i membri del gruppo è stata aggiornata per riflettere lo stato di invio.",
    "project_already_submitted": "Hai già inviato questo progetto. Contatta <email/> se devi inviarlo nuovamente.",
    "project_waived": "Il tuo progetto è stato contrassegnato come superato. Hai ricevuto il punteggio completo per questo compito.",
    "return_to_dashboard": "Torna alla dashboard"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.submission_form = window.locales.zh.submission_form || {};window.locales.zh.submission_form = {...window.locales.zh.submission_form, ...{
    "title": "提交您的项目",

                          
    "description": "要提交您的项目，请填写此表格。不要通过电子邮件提交。如有任何问题，请联系{email}。",
    "description_group_project": "要提交您的项目，请填写此表格。不要通过电子邮件提交。如有任何问题，请联系{email}。\n\n对于小组提交，请确保所有小组成员都单独上传相同的项目。",
    "individual_submission_banner_message": "<medium>您正在单独提交</medium><regular>尚未为此项目设置小组。如果您正在小组中工作，请在提交前创建小组。</regular>",
    "group_project_submission_banner_message": "<medium>您正在代表您的小组提交</medium><regular>所有小组成员将获得相同的分数和反馈。只有一名成员可以代表小组提交。</regular>",
    "create_group": "创建小组",
    "view_group": "查看小组",

                            
    "group_project_label": "协作类型",
    "group_project_description": "您是单独工作还是团队合作？",
    "collaboration_type_individual_radio_label": "个人",
    "collaboration_type_group_radio_label": "小组",
    "group_project_agreement_description": "请上传您签署的小组项目协议副本",
    "group_project_agreement_file_input_button_text": "上传小组项目协议",
    "group_project_agreement_file_input_note": "文件最大尺寸10MB",

                                                                                
    "file_input_button_text": "上传文件",
    "file_input_note": "文件最大尺寸40MB",
    "file_type_error_pdf": "请提交PDF文档。",
    "file_type_error_xlsx": "请提交Excel电子表格（.xlsx）。",
    "file_type_error_zip": "请提交ZIP文件。",
    "link_input_label": "在此粘贴链接",
    "spreadsheet_google_sheets_guidance": "如果您使用的是 Google Sheets，请将电子表格下载为 Excel 文件 (.xlsx)：转到 文件 → 下载 → Microsoft Excel (.xlsx)。",

                                 
                         
    "format_github_link_label": "GitHub 仓库链接",
    "format_github_link_description": "请提供GitHub URL。",
    "format_github_link_error": "请提供有效的GitHub URL（例如：https://github.com/username/repository）",

                               
    "format_presentation_link_label": "演示链接",
    "format_presentation_link_description": "请提供视频演示URL。",
    "format_presentation_link_error": "请提供有效的URL",

                 
    "format_pdf_label": "项目文件",
    "format_pdf_description": "请上传PDF文件。",

                         
    "format_spreadsheet_label": "电子表格文件",
    "format_spreadsheet_description": "请上传电子表格文件。",

                 
    "format_zip_label": "项目文件",
    "format_zip_description": "请上传ZIP文件。",

                          
    "format_generic_link_label": "项目链接",
    "format_generic_link_description": "请提供URL。",

                           
    "requirements_label_standard_capstone": "项目要求",
    "requirements_label_presentation": "演示要求",
    "requirements_confirm_label": "我确认我的项目提交符合上述和项目提示中指定的要求。",
    "requirements_confirm_group_project_label": "我确认这是我们的最终项目，并承认所有成员将获得相同的分数和反馈。",

                         
    "submit_project": "提交项目",
    "submitting": "正在提交，请稍候...",

                        
    "project_submitted_success": "成功！您的项目已提交！您的仪表板已更新以反映您的提交状态。",
    "individual_project_submitted_success": "<semi-strong>成功！您的项目已提交！</semi-strong>您的仪表板已更新以反映您的提交状态。",
    "group_project_submitted_success": "<semi-strong>成功！您的项目已代表您的小组提交。</semi-strong>所有小组成员的仪表板已更新以反映提交状态。",
    "project_already_submitted": "您已经提交了此项目。如需重新提交，请联系<email/>。",
    "project_waived": "您的项目已被标记为通过。您已获得此作业的满分。",
    "return_to_dashboard": "返回仪表板"
}
};